// Keep the count honest at abbreviation boundaries (1,099 likes is 1k, not 1.1k).
// The feed deliberately uses the same Latin "k" suffix in every language.
export function formatLikeCount(value) {
  const numericValue = Number(value);
  const count = Number.isFinite(numericValue) ? Math.max(0, Math.floor(numericValue)) : 0;
  if (count < 1000) return String(count);
  // Whole thousands keep large totals legible beside four 48px actions, even
  // with increased text size. The full total remains on the button's title.
  if (count >= 100000) return `${Math.floor(count / 1000)}k`;
  return `${Math.floor(count / 100) / 10}k`;
}
